import Avatar from '@xunlei/thunder-ui-vue/lib/avatar.js';
export { default as Avatar } from '@xunlei/thunder-ui-vue/lib/avatar.js';
import BrowserTab from '@xunlei/thunder-ui-vue/lib/browser-tab.js';
export { default as BrowserTab } from '@xunlei/thunder-ui-vue/lib/browser-tab.js';
import Badge from '@xunlei/thunder-ui-vue/lib/badge.js';
export { default as Badge } from '@xunlei/thunder-ui-vue/lib/badge.js';
import Button from '@xunlei/thunder-ui-vue/lib/button.js';
export { default as Button } from '@xunlei/thunder-ui-vue/lib/button.js';
import Checkbox from '@xunlei/thunder-ui-vue/lib/checkbox.js';
export { default as Checkbox } from '@xunlei/thunder-ui-vue/lib/checkbox.js';
import Collapse from '@xunlei/thunder-ui-vue/lib/collapse.js';
export { default as Collapse } from '@xunlei/thunder-ui-vue/lib/collapse.js';
import ContextMenu from '@xunlei/thunder-ui-vue/lib/context-menu.js';
export { default as ContextMenu } from '@xunlei/thunder-ui-vue/lib/context-menu.js';
import Dialog from '@xunlei/thunder-ui-vue/lib/dialog.js';
export { default as Dialog } from '@xunlei/thunder-ui-vue/lib/dialog.js';
import Dropdown from '@xunlei/thunder-ui-vue/lib/dropdown.js';
export { default as Dropdown } from '@xunlei/thunder-ui-vue/lib/dropdown.js';
import Icon from '@xunlei/thunder-ui-vue/lib/icon.js';
export { default as Icon } from '@xunlei/thunder-ui-vue/lib/icon.js';
import Input from '@xunlei/thunder-ui-vue/lib/input.js';
export { default as Input } from '@xunlei/thunder-ui-vue/lib/input.js';
import InputGroup from '@xunlei/thunder-ui-vue/lib/input-group.js';
export { default as InputGroup } from '@xunlei/thunder-ui-vue/lib/input-group.js';
import List from '@xunlei/thunder-ui-vue/lib/list.js';
export { default as List } from '@xunlei/thunder-ui-vue/lib/list.js';
import Loading from '@xunlei/thunder-ui-vue/lib/loading.js';
export { default as Loading } from '@xunlei/thunder-ui-vue/lib/loading.js';
import Media from '@xunlei/thunder-ui-vue/lib/media.js';
export { default as Media } from '@xunlei/thunder-ui-vue/lib/media.js';
import Pagination from '@xunlei/thunder-ui-vue/lib/pagination.js';
export { default as Pagination } from '@xunlei/thunder-ui-vue/lib/pagination.js';
import Progress from '@xunlei/thunder-ui-vue/lib/progress.js';
export { default as Progress } from '@xunlei/thunder-ui-vue/lib/progress.js';
import Radio from '@xunlei/thunder-ui-vue/lib/radio.js';
export { default as Radio } from '@xunlei/thunder-ui-vue/lib/radio.js';
import Rate from '@xunlei/thunder-ui-vue/lib/rate.js';
export { default as Rate } from '@xunlei/thunder-ui-vue/lib/rate.js';
import Select from '@xunlei/thunder-ui-vue/lib/select.js';
export { default as Select } from '@xunlei/thunder-ui-vue/lib/select.js';
import Table from '@xunlei/thunder-ui-vue/lib/table.js';
export { default as Table } from '@xunlei/thunder-ui-vue/lib/table.js';
import Tabs from '@xunlei/thunder-ui-vue/lib/tabs.js';
export { default as Tabs } from '@xunlei/thunder-ui-vue/lib/tabs.js';
import Tooltip from '@xunlei/thunder-ui-vue/lib/tooltip.js';
export { default as Tooltip } from '@xunlei/thunder-ui-vue/lib/tooltip.js';
import Tree from '@xunlei/thunder-ui-vue/lib/tree.js';
export { default as Tree } from '@xunlei/thunder-ui-vue/lib/tree.js';
import Message from '@xunlei/thunder-ui-vue/lib/message.js';
export { default as Message } from '@xunlei/thunder-ui-vue/lib/message.js';
import Slider from '@xunlei/thunder-ui-vue/lib/slider.js';
export { default as Slider } from '@xunlei/thunder-ui-vue/lib/slider.js';
import Switch from '@xunlei/thunder-ui-vue/lib/switch.js';
export { default as Switch } from '@xunlei/thunder-ui-vue/lib/switch.js';
import load from '@xunlei/thunder-ui-vue/lib/directives/load.js';
export { default as load } from '@xunlei/thunder-ui-vue/lib/directives/load.js';
import loading from '@xunlei/thunder-ui-vue/lib/directives/loading.js';
export { default as loading } from '@xunlei/thunder-ui-vue/lib/directives/loading.js';
import Carousel from '@xunlei/thunder-ui-vue/lib/carousel.js';
export { default as Carousel } from '@xunlei/thunder-ui-vue/lib/carousel.js';
import CarouselItem from '@xunlei/thunder-ui-vue/lib/carousel-item.js';
export { default as CarouselItem } from '@xunlei/thunder-ui-vue/lib/carousel-item.js';
import Breadcrumb from '@xunlei/thunder-ui-vue/lib/breadcrumb.js';
export { default as Breadcrumb } from '@xunlei/thunder-ui-vue/lib/breadcrumb.js';
import TreePlus from '@xunlei/thunder-ui-vue/lib/tree-plus.js';
export { default as TreePlus } from '@xunlei/thunder-ui-vue/lib/tree-plus.js';
import Viewer from '@xunlei/thunder-ui-vue/lib/viewer.js';
import VirtualList from '@xunlei/thunder-ui-vue/lib/virtual-list.js';
export { default as VirtualList } from '@xunlei/thunder-ui-vue/lib/virtual-list.js';
import InputNumber from '@xunlei/thunder-ui-vue/lib/input-number.js';
export { default as InputNumber } from '@xunlei/thunder-ui-vue/lib/input-number.js';

/**
 * thunder-ui-vue
 * (c) 2018 sunbinbin@xunlei.com
 * @license MIT
 */

var ThunderUIVue = {};

/**
 * Plugin API
 */
ThunderUIVue.install = function (Vue, options) {
  Vue.use(Avatar);
  Vue.use(Badge);
  Vue.use(BrowserTab);
  Vue.use(Button);
  Vue.use(Carousel);
  Vue.use(Checkbox);
  Vue.use(Collapse);
  Vue.use(ContextMenu);
  Vue.use(Dialog);
  Vue.use(Dropdown);
  Vue.use(Icon);
  Vue.use(Input);
  Vue.use(InputGroup);
  Vue.use(List);
  Vue.use(Loading);
  Vue.use(Media);
  Vue.use(Pagination);
  Vue.use(Progress);
  Vue.use(Radio);
  Vue.use(Rate);
  Vue.use(Select);
  Vue.use(Table);
  Vue.use(Tabs);
  Vue.use(Tooltip);
  Vue.use(Tree);
  Vue.use(Message);
  Vue.use(Slider);
  Vue.use(Switch);
  Vue.use(load);
  Vue.use(loading);
  Vue.use(CarouselItem);
  Vue.use(Breadcrumb);
  Vue.use(TreePlus);
  Vue.use(Viewer);
  Vue.use(VirtualList);
  Vue.use(InputNumber);
};

/**
 * Auto install
 */
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(ThunderUIVue);
}

export default ThunderUIVue;
